import { Button, HStack, Stack, Text, useDisclosure } from '@chakra-ui/react';

import type { AssignmentFormData } from '../../../../types/assignmentTypes';
import { Plus } from '@/client/components/icons/ContinuIcons';
import TriggerObjectBanner from '../TriggerObjectBanner';
import TriggerObjectSelectionModal from '../TriggerObjectSelectionModal';
import { WorkflowType } from '@/client/services/api/graphql/gql/graphql';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function CompletedContentForm() {
  const { t } = useTranslation();
  const {
    watch,
    formState: { errors },
  } = useFormContext<AssignmentFormData>();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { settings } = watch();
  const { triggerObject } = settings;

  const hasTriggerObject = !!triggerObject?.id && !!triggerObject?.title;

  const hasError = !!errors?.settings?.triggerObject;

  return (
    <Stack>
      <Text variant="createLabel" color={hasError ? 'error' : 'baseBlack'}>
        {t('admin.assignments.automations.contentCompleted.selectContent')}
      </Text>

      {hasTriggerObject && <TriggerObjectBanner onOpen={onOpen} />}

      {!hasTriggerObject && (
        <Button
          variant="neutralDashedBorder"
          onClick={onOpen}
          borderColor={hasError ? 'error' : 'neutral.200'}
          color={hasError ? 'error' : 'neutral.400'}
        >
          <HStack>
            <Plus boxSize={3} />

            <Text>{t('admin.assignments.automations.contentCompleted.addContent')}</Text>
          </HStack>
        </Button>
      )}

      <TriggerObjectSelectionModal
        title={t('admin.assignments.automations.contentCompleted.selectContent')}
        isOpen={isOpen}
        onClose={onClose}
        workflowType={WorkflowType.CompletedContent}
      />
    </Stack>
  );
}
